<template>
  <div class="BookMarkContainer">
    <div style="width: 44px">
      <img :src="data.avatar"
           class="sqr36 brd20"/>
    </div>
    <div style="width: calc(100% - 44px)" class="colFlex">
      <span class="boldFont">{{ data.userName }}</span>
      <span class="ft14 lightText mt6">{{data.content}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "BookMark",
  props: {
    data: {
      type: Object,
      default: ()=>{
        return {

        }
      }
    },
  },
  methods: {
    init() {

    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.BookMarkContainer {
  display: flex;
  background-color: white;
  padding: 16px;
}
</style>